<template>
  <div style="padding-bottom:50px;">
    <div v-show="loading || global_loader || loadingCatalog" class="loading">
      <i  class="fa fa-3x fa-spinner fa-spin"></i>
    </div>
    <div class="container" v-if="welcomeMessage && orders_loaded">
      <div class="row" style="background-color: #ffffff;">
        <div class="col-xs-10 col-md-11">
          <h2 class="hidden-sm hidden-xs" style="padding-left: 90px;">Welcome to My Audio Modeling <br> Customer Portal</h2>
          <h2 class="hidden-md hidden-lg" style="padding-left: 10px;">Welcome to My Audio Modeling <br> Customer Portal</h2>
        </div>
        <div class="col-xs-2 col-md-1">
          <a class="btn" style="border-style: none; box-shadow: 0 0 0 0;" href="javascript:void(0)" v-on:click="welcomeMessageExit(checked)">
            <h1>x</h1>
          </a>
        </div>
      </div>
      <div class="row" style="background-color: #ffffff;">
        <div class="col-md-12">
          <h3 style="font-weight: lighter;">
            On this portal you can redeem your purchases, download product installers,<br>
            manage your activations, change your privacy preferences, download trial / <br>
            FREE products and get exclusive offers, only for you! Let's start now.<br>
          </h3>
        </div>
      </div>
      <div class="row" style="background-color: #ffffff;">
<!--        <a href="/add-order">
          <div class="col-md-3" style="padding-bottom:70px; padding-top: 15px; border: #0c0c0c;">
            <div style="border-style: solid; border-width: 1px; margin-left: 25px; margin-right: 25px; height: 150px;">
              <h4 style="margin-top: 10%;">
                I just have<br>
                purchased a<br>
                product, I want to<br>
                register<br>
                my products
              </h4>
            </div>
          </div>
        </a>-->
        <a href="Javascript:void(0)" @click="goAddOrder">
          <div class="col-md-3" style="padding-bottom:70px; padding-top: 15px; border: #0c0c0c;">
            <div style="border-style: solid; border-width: 1px; margin-left: 25px; margin-right: 25px; height: 150px;">
              <h4 class="hidden-xs hidden-sm" style="margin-top: 18%;">
                I just have<br>
                purchased a<br>
                product, I want to<br>
                register my products
              </h4>
              <h3 class="hidden-md hidden-lg" style="margin-top: 7%;">
                I just have<br>
                purchased a<br>
                product, I want to<br>
                register my products
              </h3>
            </div>
          </div>
        </a>
        <a href="Javascript:void(0)" @click="welcomeMessageExit(checked, 'your')">
          <div class="col-md-3" style="padding-bottom:70px; padding-top: 15px; border: #0c0c0c;">
            <div style="border-style: solid; border-width: 1px; margin-left: 25px; margin-right: 25px; height: 150px;">
              <h4 class="hidden-xs hidden-sm" style="margin-top: 20%;">
                I have registered <br>
                my products and <br>
                I want to install <br>
                them
              </h4>
              <h3 class="hidden-md hidden-lg" style="margin-top: 7%;">
                I have registered <br>
                my products and <br>
                I want to install <br>
                them
              </h3>
            </div>
          </div>
        </a>
        <a href="Javascript:void(0)" @click="welcomeMessageExit(checked, 'only')">
          <div class="col-md-3" style="padding-bottom:70px; padding-top: 15px; border: #0c0c0c;">
            <div style="border-style: solid; border-width: 1px; margin-left: 25px; margin-right: 25px; height: 150px;">
              <h4 class="hidden-xs hidden-sm" style="margin-top: 20%;">
                I would like to<br>
                check the Upgrade<br>
                offers for me
              </h4>
              <h3 class="hidden-md hidden-lg" style="margin-top: 9%;">
                I would like to<br>
                check the Upgrade<br>
                offers for me
              </h3>
            </div>
          </div>
        </a>
        <a href="Javascript:void(0)" @click="welcomeMessageExit(checked, 'your')">
          <div class="col-md-3" style="padding-bottom:70px; padding-top: 15px; border: #0c0c0c;">
            <div style="border-style: solid; border-width: 1px; margin-left: 25px; margin-right: 25px; height: 150px;">
              <h4 class="hidden-xs hidden-sm" style="margin-top: 20%;">
                I signed in <br>
                to download <br>
                a free version
              </h4>
              <h3 class="hidden-md hidden-lg" style="margin-top: 9%;">
                I signed in <br>
                to download <br>
                a free version
              </h3>
            </div>
          </div>
        </a>
        <a href="/settings">
          <div class="col-md-12" style="padding-bottom:70px; padding-top: 15px; border: #0c0c0c;">
            <div style="border-style: solid; border-width: 1px; margin-left: 25px; margin-right: 25px; height: 50px;">
              <h5 class="hidden-xs hidden-sm">
                I need to manage my account
              </h5>
              <h3 class="hidden-md hidden-lg" style="margin-top: 10px;">
                I need to manage my account
              </h3>
            </div>
          </div>
        </a>
      </div>
      <div class="row" style="background-color: #ffffff;">
        <div class="col-md-12">
          <div style="padding-bottom: 10px;">
            <label style="font-size: 16px; display: inline-flex !important;" for="dontshowcheck">
              <input type="checkbox" id="dontshowcheck" class="check-am" v-model="checked">
              Don't show it again, just bring me to the Home
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="!welcomeMessage">
      <!-- MODAL -->
      <div class="modal fade" id="myModal" name="myModal" role="dialog">
        <div class="modal-dialog" style="width: 50vw; height: 75vh;">
          <!-- Modal content-->
          <div class="modal-content">
            <div v-if="modalProduct !== null">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" data-target="#myModal">&times;</button>
                <h4 class="modal-title hidden-xs hidden-sm" style="font-weight: bold; color: black;">Upgrade Offer Details</h4>
                <h6 class="modal-title hidden-md hidden-lg" style="font-weight: bold; color: black;">Upgrade Offer Details</h6>
              </div>
              <div class="modal-body" style="text-align: left; border-bottom: 1px solid #e5e5e5; color: black;">
                <h4 class="modal-title hidden-xs hidden-sm" style="font-weight: bold;"><span v-if="!modalProduct.isBundle">Upgrade to</span><span v-else>Complete Bundle</span></h4>
                <h6 class="modal-title hidden-md hidden-lg" style="font-weight: bold;"><span v-if="!modalProduct.isBundle">Upgrade to</span><span v-else>Complete Bundle</span></h6>
                <p style="font-size: 18px; font-weight: 500">
                  {{ modalProduct.ProductName }}
                </p>
              </div>
              <div class="modal-body" style="text-align: left; border-bottom: 1px solid #e5e5e5; color: black;">
                <h4 class="modal-title hidden-xs hidden-sm" style="font-weight: bold;">Products you are eligible for this upgrade</h4>
                <h6 class="modal-title hidden-md hidden-lg" style="font-weight: bold;">Products you are eligible for this upgrade</h6>
                <p class="hidden-xs hidden-sm" style="font-size: 18px; font-weight: 500" v-for="(prodFrom, index) in modalProduct.from" v-if="modalProduct.isBundle">
                  {{prodFrom.ProductName}}
                </p>
                <p class="hidden-md hidden-lg" style="font-size: 14px; font-weight: 500" v-for="(prodFrom, index) in modalProduct.from" v-if="modalProduct.isBundle">
                  {{prodFrom.ProductName}}
                </p>
                <p class="hidden-xs hidden-sm" style="font-size: 18px; font-weight: 500" v-if="modalProduct.isUpgrade">
                  {{modalProduct.from.ProductName}}
                </p>
                <p class="hidden-md hidden-lg" style="font-size: 14px; font-weight: 500" v-if="modalProduct.isUpgrade">
                  {{modalProduct.from.ProductName}}
                </p>
              </div>
              <div class="modal-body" style="text-align: left; border-bottom: 1px solid #e5e5e5; color: black;">
                <h4 class="modal-title hidden-xs hidden-sm" style="font-weight: bold;">Products you are going to purchase</h4>
                <h6 class="modal-title hidden-md hidden-lg" style="font-weight: bold;">Products you are going to purchase</h6>
                

                <p class="hidden-xs hidden-sm" style="font-size: 18px; font-weight: 500" v-for="(prodCart, index) in modalCart">
                  {{prodCart}}
                </p>
                <p class="hidden-md hidden-lg" style="font-size: 14px; font-weight: 500" v-for="(prodCart, index) in modalCart">
                  {{prodCart}}
                </p>

                <!-- Inizio blocco mobile desktop -->
                <div class="hidden-xs hidden-sm" v-if="modalProduct.isUpgrade" style="width: 300px; margin-right: auto; margin-left: auto;">

                  <button @click="modalProduct.price > modalProduct.special_price ? addToCartBundle(modalProduct.addToCart,modalProduct.special_price) : addToCart(modalProduct)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="modalProduct.validUntil != null">
                    <span style="position: relative; font-size: 18px; font-weight: bold;"><span v-if="!modalProduct.isBundle">UPGRADE FOR ONLY</span><span v-else>COMPLETE BUNDLE FOR</span></span><br>
                    <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(Math.max(modalProduct.price,modalProduct.special_price)) }}</span> <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(Math.min(modalProduct.price,modalProduct.special_price))}} {{ modalProduct.currency }}</span><br>
                    <span style="font-size: 15.5px; font-weight: bold; position: relative; top: -10px;" v-if="modalProduct.validUntil">VALID UNTIL {{Intl.DateTimeFormat("en-US", optionDate).format(new Date(modalProduct.validUntil))}}</span>
                  </button>
                  <button @click="modalProduct.price > modalProduct.special_price ? addToCartBundle(modalProduct.addToCart,modalProduct.special_price) : addToCart(modalProduct)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="modalProduct.validUntil === null">
                    <span style="position: relative; font-size: 18px; font-weight: bold;"><span v-if="!modalProduct.isBundle">UPGRADE FOR ONLY</span><span v-else>COMPLETE BUNDLE FOR</span></span><br>
                    
                    <div v-if="modalProduct.special_price < modalProduct.price">
                                <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(modalProduct.price) }}</span> <span v-if="modalProduct.special_price != modalProduct.price" style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(modalProduct.special_price)}} {{ modalProduct.currency }}</span>
                              </div>
                              <div v-else>
                                <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(modalProduct.special_price)}} {{ modalProduct.currency }}</span>
                              </div>
                  </button>
                </div>
                <div class="hidden-md hidden-lg" v-if="modalProduct.isUpgrade" style="width: 300px; margin-right: auto; margin-left: auto;">
                  <button @click="modalProduct.price > modalProduct.special_price ? addToCartBundle(modalProduct.addToCart,modalProduct.special_price) : addToCart(modalProduct)" class="btn avangate_button" style="width: 100%; height: 100px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="modalProduct.validUntil !== null">
                    <span style="position: relative; font-size: 12px; font-weight: bold;"><span v-if="!modalProduct.isBundle">UPGRADE FOR ONLY</span><span v-else>COMPLETE BUNDLE FOR</span></span><br>
                    <span style="font-size: 12px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(Math.max(modalProduct.price,modalProduct.special_price)) }}</span> <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(Math.min(modalProduct.price,modalProduct.special_price))}} {{ modalProduct.currency }}</span><br>
                    <span v-if="modalProduct.validUntil" style="font-size: 9px; font-weight: bold; position: relative; top: -10px;">VALID UNTIL {{Intl.DateTimeFormat("en-US", optionDate).format(new Date(modalProduct.validUntil))}}</span>
                  </button>
                  <button @click="modalProduct.price > modalProduct.special_price ? addToCartBundle(modalProduct.addToCart,modalProduct.special_price) : addToCart(modalProduct)" class="btn avangate_button" style="width: 100%; height: 100px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="modalProduct.validUntil === null">
                    <span style="position: relative; font-size: 12px; font-weight: bold;"><span v-if="!modalProduct.isBundle">UPGRADE FOR ONLY</span><span v-else>COMPLETE BUNDLE FOR</span></span><br>
                    <div v-if="modalProduct.special_price < modalProduct.price">
                                <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(modalProduct.price) }}</span> <span v-if="modalProduct.special_price != modalProduct.price" style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(modalProduct.special_price)}} {{ modalProduct.currency }}</span>
                              </div>
                              <div v-else>
                                <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(modalProduct.special_price)}} {{ modalProduct.currency }}</span>
                              </div>
                  </button>
                </div>
                <!-- Fine blocco mobile desktop -->

                <!-- Inizio blocco mobile desktop -->
                <div class="hidden-xs hidden-sm" v-if="modalProduct.isBundle" style="width: 300px; margin-right: auto; margin-left: auto;">
                  <button @click="modalProduct.price > modalProduct.special_price ? addToCartBundle(modalProduct.addToCart,modalProduct.special_price) : addToCart(modalProduct)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;">
                    <span style="position: relative; font-size: 18px; font-weight: bold;"><span v-if="!modalProduct.isBundle">UPGRADE FOR ONLY</span><span v-else>COMPLETE BUNDLE FOR</span></span><br>
                    <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(Math.max(modalProduct.price,modalProduct.special_price)) }}</span>
                    <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(Math.min(modalProduct.price,modalProduct.special_price))}} {{ modalProduct.currency }}</span>
                    <br>
                    <span v-if="modalProduct.validUntil" style="font-size: 15.5px; font-weight: bold; position: relative; top: -10px;">VALID UNTIL {{Intl.DateTimeFormat("en-US", optionDate).format(new Date(modalProduct.validUntil))}}</span>
                  </button>
                </div>
                <div class="hidden-md hidden-lg" v-if="modalProduct.isBundle" style="width: 150px; margin-right: auto; margin-left: auto;">
                  <button @click="modalProduct.price > modalProduct.special_price ? addToCartBundle(modalProduct.addToCart,modalProduct.special_price) : addToCart(modalProduct)" class="btn avangate_button" style="width: 100%; height: 100px; background-color: #e02222; color: #ffffff; border-radius: 10px;">
                    <span style="position: relative; font-size: 14px; font-weight: bold;"><span v-if="!modalProduct.isBundle">UPGRADE FOR ONLY</span><span v-else>COMPLETE BUNDLE FOR</span></span><br>
                    <span style="font-size: 12px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(modalProduct.price) }}</span>
                    <span style="position: relative; top: -2px; font-weight: bold; font-size: 18px;">{{parseInt(modalProduct.special_price)}} {{ modalProduct.currency }}</span>
                    <br>
                    <span v-if="modalProduct.validUntil" style="font-size: 15.5px; font-weight: bold; position: relative; top: -10px;">VALID UNTIL {{Intl.DateTimeFormat("en-US", optionDate).format(new Date(modalProduct.validUntil))}}</span>
                  </button>
                </div>
                <!-- Fine blocco mobile desktop -->
              </div>
              <div class="modal-footer" style="text-align: center;">
                <p class="hidden-xs hidden-sm" style="font-size: 14px; font-weight: 500; font-style: italic;">
                  The price has been calculated considering the products you own with the upgrade price paths explained
                  <a href="https://audiomodeling.com/swam-engine/#upgrade-section" target="_blank">here</a>
                </p>
                <p class="hidden-md hidden-lg" style="font-size: 10px; font-weight: 500; font-style: italic;">
                  The price has been calculated considering the products you own with the upgrade price paths explained
                  <a href="https://audiomodeling.com/swam-engine/#upgrade-section" target="_blank">here</a>
                </p>
                <!--              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FINE MODAL -->
      <div v-show="loading && global_loader && loadingCatalog" class="loading">
        <i  class="fa fa-3x fa-spinner fa-spin"></i>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="widget-wrap">
            <div class="widget-container margin-top-0">

              <div v-show="orders_loaded && myorders" class="widget-content">
                <div class="row">
                  <div class="col-md-12">
                    <ul class="nav nav-tabs nav-justified">
                      <li role="presentation" id="all" :style="(getAll && !getPurchases && !getBuy) ? 'font-weight: bold; border-bottom: thin solid;' : 'font-weight: normal; border-bottom: none;'">
                        <a href="Javascript:void(0)" style="color: #000000; background-color: transparent; font-size: 20px;" v-on:click="selectTab('all')">All Catalogue</a>
                      </li>
                      <li role="presentation" id="your" :style="(getPurchases && !getAll && !getBuy) ? 'font-weight: bold; border-bottom: thin solid;' : 'font-weight: normal; border-bottom: none;'">
                        <a href="Javascript:void(0)" style="color: #000000; background-color: transparent; font-size: 20px;" v-on:click="selectTab('your')">Your Products</a>
                      </li>
                      <li role="presentation" id="only" :style="(getBuy && !getPurchases && !getAll) ? 'font-weight: bold; border-bottom: thin solid;' : 'font-weight: normal; border-bottom: none;'">
                        <a href="Javascript:void(0)" style="color: #000000; background-color: transparent; font-size: 20px;" v-on:click="selectTab('only')">Only for you<span class="badge badge-notify" style="top: 0; right: 0;">{{totalProdOnlyForYou}}</span><!--<small style="display:block; margin-top:-8px; font-size:13px;"><b>Black Friday Deals</b></small>--></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div v-if="orders_loaded" class="widget-content">
                <div class="row">
                  <div class="col-md-12">
<!--                    <div class="w-section-header">
                      <h1>Your Products</h1>
                      <h1 class="inline hidden">Vendor</h1>
                      <label class="input select hidden">
                        <select v-model="mycompany" @change="getOrders()" class="form-control">
                          <option v-for="(item, index) in companies" v-bind:value="item.id">{{ item.name }}</option>
                        </select>
                        <i></i>
                      </label>
                    </div>-->
                    <div class="row" v-if="err">
                      <div class="col-xs-12 error-message">
                        {{ err }}
                      </div>
                    </div>
                    <div class="row" v-if="email">
                      <div class="col-xs-12 success-message">
                        {{ email }}
                      </div>
                    </div>



                    <!-- Products -->

                    <!-- Add shop&cart -->
<!--                    <div class="row">
                      <div class="col-md-12">
                        <div class="btn-group btn-group-justified" role="group" aria-label="Basic example">
                          <div class="btn-group">
                            <button type="button" v-bind:class="[getAll ? 'btn btn-primary' : 'btn btn-default']" @click='getAll = !getAll;getPurchases=false;getBuy=false'>All</button>
                          </div>
                          <div class="btn-group">
                            <button type="button" v-bind:class="[getPurchases ? 'btn btn-primary' : 'btn btn-default']" @click='getPurchases = !getPurchases;getAll=false;getBuy=false'>Purchases</button>
                          </div>
                          <div class="btn-group" v-if="canBuy=='true'">
                            <button type="button" v-bind:class="[getBuy ? 'btn btn-primary' : 'btn btn-default']" @click='getBuy = !getBuy;getPurchases=false;getAll=false'>Buy</button>
                          </div>
                        </div>
                      </div>
                    </div>-->

                    <!-- All Catalogue -->
                    <div class="row" v-for="(family, index) in familyCatalog" v-show="getAll && catalog" style="padding-top: 20px;">
                        <div class="col-md-12">
                          <a class="" role="button" data-toggle="collapse" :href="'#'+family.split(' ').join('').split('/').join('')" aria-expanded="false" :aria-controls="family" v-on:click.prevent="showActiveAll(family)" style="font-size:1.5em">
                            <div class="wrapper" style="border-bottom: thin solid #667;">
                              <h4 class="pull-left" style="color: #667; font-weight: bold; margin-bottom: 2px;">{{family}}</h4>
                              <i class="fa fa-caret-down pull-right" style="color: #667;" v-show="activeAll[family]"></i>
                              <i class="fa fa-caret-right pull-right" style="color: #667;" v-show="!activeAll[family]"></i>
                              <div style="clear:both; float:none"></div>
                            </div>
                          </a>
                        </div>
                        <div class="collapse" :id="family.split(' ').join('')">

                          <div style="margin-top: 25px;" class="col-md-4 col-sm-6 prodotto" v-for="(product, indice) in catalog" v-if="(product.family === family) || (family === 'Bundles' && product.isBundle)">
                            <div>
                              <div style="position: relative;">
                                <div v-if="product.discontinued === '1'">
                                  <div class="rectangle-discontinue rectangle-discontinue-color">
                                    <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px; font-size: 13px;">
                                      Discontinued
                                    </h4>
                                  </div>
                                </div>

                                <div v-if="product.license_type !== undefined && product.license_type !== null">
                                  <!-- Trial -->
                                  <div class="rectangle rectangle-trial" :class="{expired:product.expired}" v-if="product.license_type === 'TRIAL' || product.license_type === 'trial'">
                                      <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px;">
                                        {{ product.license_type }} <span v-if="product.expired">EXPIRED</span>
                                      </h4>
                                  </div>
                                  <div class="triangle triangle-trial" :class="{expired:product.expired}" v-if="product.license_type === 'TRIAL' || product.license_type === 'trial'">
                                  </div>
                                  <!-- NFR -->
                                  <div class="rectangle rectangle-nfr" v-if="product.license_type === 'NFR' || product.license_type === 'nfr'">
                                    <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px;">
                                      {{ product.license_type }}
                                    </h4>
                                  </div>
                                  <div class="triangle triangle-nfr" v-if="product.license_type === 'NFR' || product.license_type === 'nfr'">
                                  </div>
                                  <!-- FREE -->
                                  <div class="rectangle rectangle-free" v-if="product.license_type === 'FREE' || product.license_type === 'free'">
                                    <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px;">
                                      {{ product.license_type }}
                                    </h4>
                                  </div>
                                  <div class="triangle triangle-free" v-if="product.license_type === 'FREE' || product.license_type === 'free'">
                                  </div>
                                </div>

                                <!-- Menù contestuale -->
                                <ul class="pull-right top-right-icons" v-if="!product.isBundle || (product.product_page_url !== null && !purchased(product.id)) || product.license_type === 'FREE'">
                                  <li class="dropdown apps-dropdown" style="margin: 0px; position: absolute; top: -18px; right: 10px;">
                                    <a href="Javascript:void(0)" data-toggle="dropdown" style="position: absolute; top: 18px; right: -10px; border:1px solid #000; border-radius:50px; z-index: 10;">
                                      <img src="static/images/menu.png" style="height: 40px;">
                                    </a>

                                    <div class="dropdown-menu" style="margin-top: 45px;">
                                      <ul class="more-apps">
                                        <li style="font-weight: bolder;" v-if="product.license_type === 'FREE'">Install and Update</li>
                                        <ul class="more-apps" v-if="product.license_type === 'FREE'">
                                          <li style="padding-left: 6px;">
                                            <a class="truncate" href="https://audiomodeling.com/support/install-and-update" target="_blank">Software Center</a>
                                          </li>
                                          <!--<li style="padding-left: 6px;" v-for="download in myproducts[indexMyProd(product.id)].downloads" v-if="download.operating_system === 'Mac OSX'">
                                            <a class="truncate" href="Javascript:void(0)">Mac OSX {{download.product_version}}</a>
                                          </li>
                                          <li style="padding-left: 6px;" v-for="download in myproducts[indexMyProd(product.id)].downloads" v-if="download.operating_system === 'Windows'">
                                            <a class="truncate" href="Javascript:void(0)">Windows {{download.product_version}}</a>
                                          </li>-->
                                        </ul>
                                        <li style="font-weight: bolder;" v-if="purchased(product.id)">Install and Update</li>
                                        <ul class="more-apps" v-if="purchased(product.id)">
                                          <li style="padding-left: 6px;">
                                            <a class="truncate" href="https://audiomodeling.com/support/install-and-update" target="_blank">Software Center</a>
                                          </li>
                                          <!--<li style="padding-left: 6px;" v-for="download in myproducts[indexMyProd(product.id)].downloads" v-if="download.operating_system === 'Mac OSX'">
                                            <a class="truncate" href="Javascript:void(0)" @click="getToken(download.id_file, download, product)">Mac OSX {{download.product_version}}</a>
                                          </li>
                                          <li style="padding-left: 6px;" v-for="download in myproducts[indexMyProd(product.id)].downloads" v-if="download.operating_system === 'Windows'">
                                            <a class="truncate" href="Javascript:void(0)" @click="getToken(download.id_file, download, product)">Windows {{download.product_version}}</a>
                                          </li>-->
                                        </ul>
                                        <li style="font-weight: bolder;" v-if="purchased(product.id)">Additional downloads</li>
                                        <ul class="more-apps" v-if="purchased(product.id)">
                                          <li style="padding-left: 6px;" v-for="manual in myproducts[indexMyProd(product.id)].other_downloads">
                                            <a :href="manual.filepath" target="_blank">{{manual.filename}}</a>
                                          </li>
                                        </ul>
                                        <li style="font-weight: bolder;" v-if="product.product_page_url !== null">Product info</li>
                                        <ul class="more-apps" v-if="product.product_page_url !== null">
                                          <li style="padding-left: 6px;">
                                            <a :href="product.product_page_url" target="_blank">Product detail page</a>
                                          </li>
                                        </ul>
                                      </ul>
                                    </div>
                                  </li>
                                </ul>
                                <!-- Fine menù contestuale -->
                                <div v-if="product.isUpgrade && !product.parent && !purchased(product.id) && product.license_type !== 'FREE' && ((product.owned_products && product.owned_products.length < 1) || (product.owned_products === undefined || product.owned_products === null)) || !product.parent && !purchased(product.id) && product.license_type !== 'FREE' && (product.owned_products && product.owned_products.length > 0)" style="background-color: #E02222FF; padding-top: 5px; z-index: 0; position: relative; top: 0px; margin: 16px; margin-top: 15px; margin-bottom: 20px;">
                                  <h3 style="color:white; margin-bottom: -37.5px; margin-top: 2px;padding-bottom: 7px; font-weight: bold;">Upgrade Available</h3>
                                </div>
                                <a v-if="!purchased(product.id)" :href="product.product_page_url" target="_blank">
                                  <img v-if="product.image" v-bind:src="product.image" class="img-responsive" @error="imageUrlAlt">
                                  <img v-else src="static/images/no_image.jpg" class="img-responsive">
                                </a>
                                <a v-if="purchased(product.id)" href="Javascript:void(0)">
                                  <img v-if="product.image" v-bind:src="product.image" class="img-responsive" @click="getDownload( indice, product )" @error="imageUrlAlt">
                                  <img v-else src="static/images/no_image.jpg" class="img-responsive">
                                </a>
                              </div>
                            </div>
                            <div class="nomeprodotto">
                              <h4 style="margin-bottom: 3px;">{{ product.ProductName }}</h4>


                              <p v-if="!product.isBundle || (product.isBundle && !product.from.length)">V {{ product.version }}</p>
                              <p v-if="product.isBundle && product.from.length && !product.isSuperBundle">
                                ( from
                                <span v-for="(from, index) in product.from">
                                  {{from.ProductName}}
                                  <span v-if="index != product.from.length-1"> + </span>
                                </span>
                                )
                              </p>
                              <p v-if="product.isBundle && product.from.length && product.isSuperBundle">
                                V {{ product.version }}
                              </p>


                            </div>
                            <p style="width: 100%">

                              <button  v-if="!product.parent && purchased(product.id) && product.license_type !== 'FREE' && product.license_type !== 'TEST' && product.license_type !== 'TRIAL'" class="btn btn-primary" @click="getDownload( indice, product )" style="width: 100%">
                                License & Download
                              </button>
                              <button  v-if="product.license_type == 'FREE'" class="btn btn-primary" @click="getDownload( indice, product )" style="width: 100%; height: 40px;">
                                Info & Download
                              </button>
                              <template v-if="!product.isBundle">
                                <button @click="addToCart(product)" v-if="!product.isUpgrade && !product.parent && !purchased(product.id) && product.license_type !== 'FREE' && ((product.owned_products && product.owned_products.length < 1) || (product.owned_products === undefined || product.owned_products === null))" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;">
                                  <span>{{ parseInt(product.price) }} {{ product.currency }}</span>
<!--                                  <template v-if="product.isUpgrade">
                                    <span style="position: relative; top: -6px;">UPGRADE PRICE</span><br>
                                    <span style="font-size: 10px; text-decoration: line-through; position: relative; top: -16px;">{{ parseInt(product.price) }}</span> <span style="position: relative; top: -15px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                                  </template>-->
                                </button>

                                <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" v-if="product.isUpgrade && !product.parent && !purchased(product.id) && product.license_type !== 'FREE' && ((product.owned_products && product.owned_products.length < 1) || (product.owned_products === undefined || product.owned_products === null))" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;">
<!--                                  <span v-if="!product.isUpgrade">{{ parseInt(product.price) }} {{ product.currency }}</span>-->
                                  <template>
                                    <span style="position: relative; top: -6px;"><span v-if="!product.isBundle">UPGRADE PRICE</span><span v-else>COMPLETE FOR</span></span><br>
                                    <span v-if="product.special_price != product.price" style="font-size: 10px; text-decoration: line-through; position: relative; top: -16px;">{{ parseInt(Math.max(product.price, product.special_price)) }}</span> <span style="position: relative; top: -15px;">{{parseInt(Math.min(product.special_price, product.price))}} {{ product.currency }}</span>
                                  </template>
                                </button>
                                <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" v-if="!product.parent && !purchased(product.id) && product.license_type !== 'FREE' && (product.owned_products && product.owned_products.length > 0)" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;">
                                  <span style="position: relative; top: -6px;"><span v-if="!product.isBundle">UPGRADE PRICE</span><span v-else>COMPLETE FOR</span></span><br>
                                    <span  v-if="product.special_price != product.price" style="font-size: 10px; text-decoration: line-through; position: relative; top: -16px;">{{ parseInt(Math.max(product.price, product.special_price)) }}</span> <span style="position: relative; top: -15px;">{{parseInt(Math.min(product.special_price, product.price))}} {{ product.currency }}</span>
                                </button>
                              </template>

                              <template v-else>
                               
                                <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;" v-if="(product.price != product.special_price || product.price === product.special_price) && (product.owned_products.length > 0 || product.fromUpgrade.length > 0)">
                                    <span style="position: relative; top: -6px;"><span v-if="!product.isBundle">UPGRADE PRICE</span><span v-else>COMPLETE FOR</span></span><br>
                                    <span v-if="product.special_price != product.price" style="font-size: 10px; text-decoration: line-through; position: relative; top: -16px;">{{ parseInt(Math.max(product.price, product.special_price)) }}</span> <span style="position: relative; top: -15px;">{{parseInt(Math.min(product.special_price, product.price))}} {{ product.currency }}</span>
                                </button>

                                <button v-else @click="addToCart(product)" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;">
                                  <span v-if="!product.owned_products.length">{{ parseInt(product.price) }} {{ product.currency }}</span>
                                </button>
                              </template>
                              <!--                            <button  disabled v-else="product.parent" class="btn btn-default">Module unlocked</button>-->
                            </p>
                          </div>
                        </div>
                      </div>
                    <!-- End All Catalog -->

                    <!-- Your Products -->
                    <div class="row" v-for="(family, index) in familyPrice" v-show="getPurchases && myproducts" style="padding-top: 20px;">
                      <div class="col-md-12">
                        <a class="" role="button" data-toggle="collapse" :href="'#'+family.split(' ').join('').split('/').join('')" aria-expanded="false" :aria-controls="family" v-on:click.prevent="showActiveAll(family)" style="font-size:1.5em">
                          <div class="wrapper" style="border-bottom: thin solid #667;">
                            <h4 class="pull-left" style="color: #667; font-weight: bold; margin-bottom: 2px;">{{family}} <span v-if="counter[family]" class="badge badge-primary" style="position:absolute; display:inline-block; padding:6px 6px; margin-left:10px; bottom:5px; line-height:50%;">{{counter[family] ? counter[family] : 0}}</span></h4>
                            <i class="pull-right fa fa-caret-down" style="color: #667;" v-show="activeAll[family]"></i>
                            <i class="pull-right fa fa-caret-right" style="color: #667;" v-show="!activeAll[family]"></i>
                            <div style="clear:both; float:none"></div>
                          </div>
                        </a>
                      </div>
                      <div class="collapse" :id="family.split(' ').join('').split('/').join('')">
                        <!--<div class="col-md-12">
                          <p class="pull-left" v-if="family === 'PURCHASED'" style="color: #17bab8;">Manage your Licenses and activations, download the latest product installers.</p>
                          <p class="pull-left" v-if="family === 'FREE'" style="color: #17bab8;">Here you can download the installers of your available FREE Products.</p>
                          <p class="pull-left" v-if="family === 'TRIAL / EVALUATION'" style="color: #17bab8;">Here you can download the installers and documentation of your Trial Products.</p>
                        </div>-->

                        <div style="margin-top: 25px;" class="col-md-4 col-sm-6 prodotto" v-for="(product, indice) in myproducts" v-if="familyPriceChoice(product, family)">

                          <div>
                            <div style="position: relative;">
                              <div v-if="product.discontinued === '1'">
                                <div class="rectangle-discontinue rectangle-discontinue-color">
                                  <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px; font-size: 13px;">
                                    Discontinued
                                  </h4>
                                </div>
                              </div>
                              <div v-if="product.license_type !== undefined && product.license_type !== null">
                                
                                <!-- Trial -->
                                <div class="rectangle rectangle-trial" :class="{expired:product.expired}" v-if="product.license_type === 'TRIAL' || product.license_type === 'trial'">
                                  <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px;">
                                    {{ product.license_type }} <span v-if="product.expired">EXPIRED</span>
                                  </h4>
                                </div>
                                <div class="triangle triangle-trial" :class="{expired:product.expired}" v-if="product.license_type === 'TRIAL' || product.license_type === 'trial'">
                                </div>
                                <!-- NFR -->
                                <div class="rectangle rectangle-nfr" v-if="product.license_type === 'NFR' || product.license_type === 'nfr'">
                                  <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px;">
                                    {{ product.license_type }}
                                  </h4>
                                </div>
                                <div class="triangle triangle-nfr" v-if="product.license_type === 'NFR' || product.license_type === 'nfr'">
                                </div>
                                <!-- FREE -->
                                <div class="rectangle rectangle-free" v-if="product.license_type === 'FREE' || product.license_type === 'free'">
                                  <h4 style="color: #ffffff; padding-top: 0px; margin-bottom: 0px; margin-top: 5px;">
                                    {{ product.license_type }}
                                  </h4>
                                </div>
                                <div class="triangle triangle-free" v-if="product.license_type === 'FREE' || product.license_type === 'free'">
                                </div>
                              </div>

                              <!-- Menù contestuale -->
                              <ul class="pull-right top-right-icons" v-if="!product.isBundle || (product.product_page_url !== null && !purchased(product.id))">
                                <li class="dropdown apps-dropdown" style="margin: 0px; position: absolute; top: -18px; right: 10px;">
                                  <a href="Javascript:void(0)" data-toggle="dropdown" style="position: absolute; top: 18px; right: -10px; border:1px solid #000; border-radius:50px;">
                                    <img src="static/images/menu.png" style="height: 40px;">
                                  </a>
                                  <div class="dropdown-menu" style="margin-top: 45px;">
                                    <ul class="more-apps">

                                      <li style="font-weight: bolder;" v-if="purchased(product.id) || product.license_type === 'FREE'">Install and Update</li>
                                      <ul class="more-apps" v-if="purchased(product.id) || product.license_type === 'FREE'">
                                        <li style="padding-left: 6px;">
                                          <a class="truncate" href="https://audiomodeling.com/support/install-and-update" target="_blank">Software Center</a>
                                        </li>
                                       <!-- <li style="padding-left: 6px;" v-for="download in myproducts[indexMyProd(product.id)].downloads" v-if="download.operating_system === 'Mac OSX'">
                                          <a class="truncate" href="Javascript:void(0)" @click="getToken(download.id_file, download, product)">Mac OSX {{download.product_version}}</a>
                                        </li>
                                        <li style="padding-left: 6px;" v-for="download in myproducts[indexMyProd(product.id)].downloads" v-if="download.operating_system === 'Windows'">
                                          <a class="truncate" href="Javascript:void(0)" @click="getToken(download.id_file, download, product)">Windows {{download.product_version}}</a>
                                        </li>-->
                                      </ul>
                                      <li style="font-weight: bolder;" v-if="purchased(product.id)">Additional downloads</li>
                                      <ul class="more-apps" v-if="purchased(product.id)">
                                        <li style="padding-left: 6px;" v-for="manual in myproducts[indexMyProd(product.id)].other_downloads">
                                          <a :href="manual.filepath" target="_blank">{{manual.filename}}</a>
                                        </li>
                                      </ul>
                                      <li style="font-weight: bolder;" v-if="product.product_page_url !== null">Product info</li>
                                      <ul class="more-apps" v-if="product.product_page_url !== null">
                                        <li style="padding-left: 6px;">
                                          <a :href="product.product_page_url" target="_blank">Product detail page</a>
                                        </li>
                                      </ul>
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                              <!-- Fine menù contestuale -->

<!--                              <a :href="product.product_page_url" target="_blank">
                                <img v-if="product.image" v-bind:src="product.image" class="img-responsive">
                                <img v-else src="static/images/no_image.jpg" class="img-responsive">
                              </a>-->
                              <a v-if="purchased(product.id) || product.license_type === 'FREE'" href="Javascript:void(0)" @click="getDownload( indice, product )">
                                <img v-if="product.image" v-bind:src="product.image" class="img-responsive">
                                <img v-else src="static/images/no_image.jpg" class="img-responsive">
                              </a>
                              <a v-if="!purchased(product.id) && product.license_type !== 'FREE'" href="product.product_page_url" target="_blank">
                                <img v-if="product.image" v-bind:src="product.image" class="img-responsive">
                                <img v-else src="static/images/no_image.jpg" class="img-responsive">
                              </a>
                            </div>
                          </div>
                          <div class="nomeprodotto">
                            <h4 style="margin-bottom: 3px;">{{ product.ProductName }}</h4>
                            <p>V {{ product.version }}</p>
                          </div>
                          <p style="width: 100%">
                            <button  v-if="!product.parent && product.license_type !== 'FREE'" :disabled="product.expired" class="btn btn-primary" @click="getDownload( indice, product )" style="width: 100%; height: 40px;">
                              License & Download
                            </button>
                            
                            <button  v-if="product.license_type === 'FREE'" class="btn btn-primary" @click="getDownload( indice, product )" style="width: 100%; height: 40px;">
                              Info & Download
                            </button>
<!--                            <button @click="addToCart(product)" v-if="!product.parent && !purchased(product.id) && product.license_type !== 'FREE' && ((product.owned_products && product.owned_products.length < 1) || (product.owned_products === undefined || product.owned_products === null))" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;">
                              <span v-if="!product.isUpgrade">{{ parseInt(product.price) }} {{ product.currency }}</span>
                              <template v-if="product.isUpgrade">
                                <span style="position: relative; top: -6px;">UPGRADE PRICE</span><br>
                                <span style="font-size: 10px; text-decoration: line-through; position: relative; top: -16px;">{{ parseInt(product.price) }}</span> <span style="position: relative; top: -15px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                              </template>
                            </button>
                            <button @click="addToCart(product)" v-if="!product.parent && !purchased(product.id) && product.license_type !== 'FREE' && ((product.owned_products && product.owned_products.length > 0))" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;">
                              <span style="position: relative; top: -6px;">UPGRADE PRICE</span><br>
                              <span style="font-size: 10px; text-decoration: line-through; position: relative; top: -16px;">{{ parseInt(product.price) }}</span> <span style="position: relative; top: -15px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                            </button>-->
                            <!--                            <button  disabled v-else="product.parent" class="btn btn-default">Module unlocked</button>-->
                          </p>
                        </div>
                      </div>
                    </div>
                    <!--                    <div class="row">
&lt;!&ndash;                      <div class="col-md-12">
                        <button class="btn btn-default btn-lg" @click="addOrder()" type="button" style="margin-top:25px;"><i class="zmdi zmdi-collection-plus"></i> Register a new product</button>
                      </div>&ndash;&gt;

                      <div class="col-md-12">
                        <div class="row prodotti" >
                          <div class="col-md-4 col-sm-6 prodotto" v-for="product, indice in myproducts" v-if="getPurchases || getAll">
                            <a :href="product.product_page_url" target="_blank"><img v-if="product.image" v-bind:src="product.image" class="img-responsive">
                              <img v-else src="static/images/product_placeholder.png" class="img-responsive"></a>
                            <div class="nomeprodotto"><h4>{{ product.ProductName }} {{ product.version }}</h4></div>
                            <p>

                              <button  v-if="!product.parent" class="btn btn-primary" @click="getDownload( indice, product )">Licenses & Downloads</button>
                              <button  disabled v-else="product.parent" class="btn btn-default">Module unlocked</button>
                            </p>
                          </div>
                          &lt;!&ndash; catalog &ndash;&gt;
                          <div class="col-md-4 col-sm-6 prodotto" v-for="product, indice in catalog" v-if="getBuy || getAll">
                            <a :href="product.product_page_url" target="_blank"><img v-if="product.image" v-bind:src="product.image" class="img-responsive" >
                              <img v-else src="static/images/product_placeholder.png" class="img-responsive" ></a>
                            <div class="nomeprodotto"><h4>{{ product.ProductName }} {{ product.version }}</h4></div>
                            <p>

                              <button class="btn btn-warning" v-if="canBuy=='true' && (product.deprecated==0 || !product.deprecated)" @click="addProduct(product.product_url)">Buy</button>
                              <a class="btn btn-warning" v-if="canBuy=='true' && product.deprecated==1" href="https://support.audiomodeling.com" target="_blank">CONTACT US</a>
                              <a class="btn btn-default" v-if="canBuy=='false'" href="javascript: void(0)" target="_blank"  @click="window.fbq('trackCustom','ProductDetail', {product: product.ProductName,family: product.family});location.href=product.product_page_url;">Product Detail</a>
                            </p>
                          </div>
                        </div>
                      </div>

                    </div>-->

                    <!-- Only for you-->
                    <div class="row" v-for="(family, index) in onlyForYou" v-show="getBuy && catalog" style="padding-top: 20px;">
<!--                      <div class="col-md-12">
                        <a class="" role="button" data-toggle="collapse" :href="'#'+family.split(' ').join('').split('/').join('')" aria-expanded="false" :aria-controls="family" v-on:click.prevent="showActiveAll(family)" style="font-size:1.5em">
                          <div class="wrapper" style="border-bottom: thin solid #17bab8;">
                            <h5 class="pull-left" style="color: #17bab8; font-weight: bold; margin-bottom: 2px;">{{family}}</h5>
                            <i class="pull-right fa fa-caret-down" v-show="activeAll[family]"></i>
                            <i class="pull-right fa fa-caret-right" v-show="!activeAll[family]"></i>
                          <div style="clear:both; float:none"></div>
                          </div>
                        </a>
                      </div>-->
<!--                      <div class="collapse" :id="family.split(' ').join('').split('/').join('')">-->
<!--                        <div class="col-md-12">
                          <p class="pull-left text-left" v-if="family === 'PRODUCTS UPGRADE'" style="color: #17bab8;">
                            Here you can see the upgrade available, depending on the product that you already have purchased.
                          </p>
                          <p class="pull-left text-left" v-if="family === 'BUNDLES COMPLETION'" style="color: #17bab8;">
                            If you have purchased a single product, you can still benefit of the Bundle offer. Check here the Bundles available for you. The options and the price are calculated considering the product you have.
                          </p>
                          &lt;!&ndash;<p class="pull-left text-left" v-if="family === 'BUNDLES COMPLETION'" style="color: #17bab8;">
                            Please note:<br>
                            - Bundle Upgrades are not avalable for older product versions.<br>
                            - ALL Upgrades: In order to be elegible to ALL In Bundle Upgrade, you need to have purchased at least one SWAM Bundle. If you one a single product you have to upgrade to the family Bundle first.
                          </p>&ndash;&gt;
                          <p class="pull-left text-left" v-if="family === 'PARTNERS\' PROMOS'" style="color: #17bab8;">
                            Discount and Offers made with our Partners.
                          </p>
                        </div>-->
                      <div class="row" v-for="(product, indice) in catalog" v-if="family === 'BUNDLES COMPLETION' && product.isBundle && ((product.from.length > 0) || (product.price !== product.special_price))">
                        <div class="col-md-12" style="padding-top: 25px; padding-bottom: 5px;">
                          <div class="col-md-4">
                            <div :style="'height: '+(150+(index*50))+'px;'">
                              <template v-for="(productForImage, indice) in product.from">
                                <img  v-if="indice % 2 != 0" :style="'height: 150px; position:absolute; left:'+25*indice+'px; margin-top:20px;'" v-bind:src="productForImage.image" class="img-responsive">
                                <img  v-else :style="'height: 150px; position:absolute; left:'+25*indice+'px; margin-top:0px;'" v-bind:src="productForImage.image" class="img-responsive">
                              </template>
                            </div>
<!--                              <div class="nomeprodotto">
                              <p style="color: black" v-if="product.isBundle && product.from.length">
                                <span style="font-weight: bold; font-size: x-large">From</span><br>
                                <span v-for="(from, index) in product.from" style="font-size: large">
                                {{from.ProductName}}
                                <span v-if="index != product.from.length-1" style="font-size: large"> + </span>
                              </span>
                              </p>
                            </div>-->
                          </div>
                          <div class="col-md-2 hidden-sm hidden-xs" style="padding-top: 50px;">
                            <img style="margin-top: auto; margin-bottom: auto; margin-left: auto; margin-right: auto;" src="static/images/right_arrow.png" class="img-responsive">
                          </div>
                          <div class="col-md-2 hidden-md hidden-lg" style="padding-top: 50px;">
                            <img style="margin-top: auto; margin-bottom: auto; margin-left: auto; margin-right: auto; transform: rotate(90deg)" src="static/images/right_arrow.png" class="img-responsive">
                          </div>
                          <div class="col-md-3">
                            <img style="height: 150px; margin-left: auto; margin-right: auto;" v-if="product.image" v-bind:src="product.image" class="img-responsive">
                            <img style="height: 150px; margin-left: auto; margin-right: auto;" v-else src="static/images/no_image.jpg" class="img-responsive">
                            <!--                              <div class="nomeprodotto">
                                                            <p style="margin-bottom: 3px; color: black; margin-bottom: 3px;">
                                                              <span style="font-weight: bold; font-size: x-large">To</span><br>
                                                              <span style="font-size: large">
                                                                {{ product.ProductName }}
                                                              </span>
                                                            </p>
                                                          </div>-->
                          </div>
                          <div class="col-md-3 hidden-sm hidden-xs">
                           
                            <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;">
                              <span style="position: relative; font-size: 18px; font-weight: bold;"><span v-if="!product.isBundle">UPGRADE FOR</span><span v-else style="line-height: 13px">COMPLETE BUNDLE FOR</span></span><br>
                              <span v-if="product.special_price != product.price" style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(Math.max(product.special_price,product.price)) }}</span>
                              <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(Math.min(product.special_price,product.price))}} {{ product.currency }}</span>
                              <div v-if="product.validUntil">
                                <span style="font-size: 13px; font-weight: bold; position: relative; top: -10px;">VALID UNTIL {{Intl.DateTimeFormat("en-US", optionDate).format(new Date(product.validUntil))}}</span>
                              </div>
                            </button>
                            <button class="btn avangate_button" style="margin-top: 13px; width: 100%; height: 40px; background-color: #ffffff; color: #e02222; border-color: #e02222; border: 2px; border-radius: 10px;" type="button" data-toggle="modal" data-target="#myModal" @click="insertIdInModal(product.id)">
                              <span style="position: relative; top: -3px; font-size: 20px; font-weight: bold; bottom: 2px;">Offer Details</span>
                            </button>
                            <!--                              <a href="https://audiomodeling.com/swam-engine/#upgrade-section" target="_blank">
                                                            <p style="color: #17bab8; font-size: 12px;">How the price is calculated?</p>
                                                          </a>-->
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="col-md-4">
                            <div class="nomeprodotto">
                              <p style="color: black" v-if="product.isBundle && product.from.length">
                                <span style="font-weight: bold; font-size: x-large">FROM:</span><br>

                                <span v-for="(from, index) in product.from" style="font-size: large">
                                  {{from.ProductName}}
                                  <span v-if="index != product.from.length-1" style="font-size: large"> + </span>
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="col-md-2">
                          </div>
                          <div class="col-md-3">
                            <div class="nomeprodotto">
                              <p style="color: black; margin-bottom: 3px;">
                                <span style="font-weight: bold; font-size: x-large">TO:</span><br>
                                <span style="font-size: large">
                                    {{product.ProductName}}
                                  </span>
                              </p>
                            </div>
                          </div>
                          <div class="col-md-3">
                          </div>
                        </div>
                        <div class="col-md-12 hidden-md hidden-lg">
                          <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;">
                            <span style="position: relative; font-size: 18px; font-weight: bold;">UPGRADE FOR</span><br>
                            <div v-if="product.special_price <= product.price">
                              <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(product.price) }}</span>
                              <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                            </div>
                            <div v-else>
                              <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.price)}} {{ product.currency }}</span>
                            </div>
                          </button>
                          <button class="btn avangate_button" style="margin-top: 13px; width: 100%; height: 40px; background-color: #ffffff; color: #e02222; border-color: #e02222; border: 2px; border-radius: 10px;" type="button" data-toggle="modal" data-target="#myModal" @click="insertIdInModal(product.id)">
                            <span style="position: relative; top: -3px; font-size: 20px; font-weight: bold; bottom: 2px;">Offer Details</span>
                          </button>
                          <!--                              <a href="https://audiomodeling.com/swam-engine/#upgrade-section" target="_blank">
                                                          <p style="color: #17bab8; font-size: 12px;">How the price is calculated?</p>
                                                        </a>-->
                        </div>
                      </div>
                      <!-- Line -->
                      <div v-if="line && family === 'BUNDLES COMPLETION'" style="border-bottom: thin solid #17bab8; padding-top: 15px;"></div>

                      <div class="row" v-for="(product, indice) in catalog" v-if="family === 'PRODUCTS UPGRADE' && product.isUpgrade && !purchased(product.id)">
                        <div class="col-md-12" style="padding-top: 25px; padding-bottom: 5px;">
                          <div class="col-md-4">
                            <img style="height: 150px; margin-left: auto; margin-right: auto;" v-if="product.from && product.from.image" v-bind:src="product.from.image" class="img-responsive">
                            <img style="height: 150px; margin-left: auto; margin-right: auto;" v-else src="static/images/no_image.jpg" class="img-responsive">
<!--                              <div class="nomeprodotto">
                              <p style="color: black">
                                <span style="font-weight: bold; font-size: x-large">FROM:</span><br>
                                <span style="font-size: large">
                                  {{product.from.ProductName}}
                                </span>
                              </p>
                            </div>-->
                          </div>
                          <div class="col-md-2 hidden-sm hidden-xs" style="padding-top: 50px;">
                            <img style="margin-top: auto; margin-bottom: auto; margin-left: auto; margin-right: auto;" src="static/images/right_arrow.png" class="img-responsive">
                          </div>
                          <div class="col-md-2 hidden-md hidden-lg" style="padding-top: 50px;">
                            <img style="margin-top: auto; margin-bottom: auto; margin-left: auto; margin-right: auto; transform: rotate(90deg)" src="static/images/right_arrow.png" class="img-responsive">
                          </div>
                          <div class="col-md-3">
                            <img style="height: 150px; margin-left: auto; margin-right: auto;" v-if="product.image" v-bind:src="product.image" class="img-responsive">
                            <img style="height: 150px; margin-left: auto; margin-right: auto;" v-else src="static/images/no_image.jpg" class="img-responsive">
<!--                              <div class="nomeprodotto">
                              <p style="color: black; margin-bottom: 3px;">
                                <span style="font-weight: bold; font-size: x-large">TO:</span><br>
                                <span style="font-size: large">
                                  {{product.ProductName}}
                                </span>
                              </p>
                            </div>-->
                          </div>
                          <div class="col-md-3 hidden-sm hidden-xs">
                            <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="product.validUntil !== null">
                              <span style="position: relative; font-size: 18px; font-weight: bold;">UPGRADE FOR ONLY</span><br>
                              <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(product.price) }}</span> <span v-if="product.special_price != product.price" style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.special_price)}} {{ product.currency }}</span><br>
                              <span v-if="product.validUntil" style="font-size: 13px; font-weight: bold; position: relative; top: -10px;">VALID UNTIL {{Intl.DateTimeFormat("en-US", optionDate).format(new Date(product.validUntil))}}</span>
                            </button>
                            <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="product.validUntil === null">
                              <span style="position: relative; font-size: 18px; font-weight: bold;">UPGRADE FOR ONLY</span><br>
                              <div v-if="product.special_price < product.price">
                                <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(product.price) }}</span> <span v-if="product.special_price != product.price" style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                              </div>
                              <div v-else>
                                <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                              </div>
                            </button>
                            <button class="btn avangate_button" style="margin-top: 13px; width: 100%; height: 40px; background-color: #ffffff; color: #e02222; border-color: #e02222; border: 2px; border-radius: 10px;" type="button" data-toggle="modal" data-target="#myModal" @click="insertIdInModal(product.id)">
                              <span style="position: relative; top: -3px; font-size: 20px; font-weight: bold; bottom: 2px;">Offer Details</span>
                            </button>
<!--                              <a href="https://audiomodeling.com/swam-engine/#upgrade-section" target="_blank">
                              <p style="color: #17bab8; font-size: 12px;">How the price is calculated?</p>
                            </a>-->
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="col-md-4">
                            <div class="nomeprodotto">
                              <p style="color: black">
                                <span style="font-weight: bold; font-size: x-large">FROM:</span><br>
                                <span style="font-size: large">
                                  {{product.from.ProductName}}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="col-md-2">
                          </div>
                          <div class="col-md-3">
                            <div class="nomeprodotto">
                              <p style="color: black; margin-bottom: 3px;">
                                <span style="font-weight: bold; font-size: x-large">TO:</span><br>
                                <span style="font-size: large">
                                  {{product.ProductName}}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="col-md-3">
                          </div>
                        </div>
                        <div class="col-md-12 hidden-md hidden-lg">
                          <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="product.validUntil !== null">
                            <span style="position: relative; font-size: 18px; font-weight: bold;">UPGRADE FOR ONLY</span><br>
                            <span v-if="product.special_price != product.price" style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(product.price) }}</span> <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.special_price)}} {{ product.currency }}</span><br>
                            <span v-if="product.validUntil" style="font-size: 13px; font-weight: bold; position: relative; top: -10px;">VALID UNTIL {{Intl.DateTimeFormat("en-US", optionDate).format(new Date(product.validUntil))}}</span>
                          </button>
                          <button @click="product.price > product.special_price ? addToCartBundle(product.addToCart,product.special_price) : addToCart(product)" class="btn avangate_button" style="width: 100%; height: 120px; background-color: #e02222; color: #ffffff; border-radius: 10px;" v-if="product.validUntil === null">
                            <span style="position: relative; font-size: 18px; font-weight: bold;">UPGRADE FOR ONLY</span><br>
                            <div v-if="product.special_price < product.price">
                                <span style="font-size: 14px; position: relative; top: -2px; text-decoration: line-through;">{{ parseInt(product.price) }}</span> <span v-if="product.special_price != product.price" style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                              </div>
                              <div v-else>
                                <span style="position: relative; top: -2px; font-weight: bold; font-size: 25px;">{{parseInt(product.special_price)}} {{ product.currency }}</span>
                              </div>
                          </button>
                          <button class="btn avangate_button" style="margin-top: 13px; width: 100%; height: 40px; background-color: #ffffff; color: #e02222; border-color: #e02222; border: 2px; border-radius: 10px;" type="button" data-toggle="modal" data-target="#myModal" @click="insertIdInModal(product.id)">
                            <span style="position: relative; top: -3px; font-size: 20px; font-weight: bold; bottom: 2px;">Offer Details</span>
                          </button>
                          <!--                              <a href="https://audiomodeling.com/swam-engine/#upgrade-section" target="_blank">
                                                        <p style="color: #17bab8; font-size: 12px;">How the price is calculated?</p>
                                                      </a>-->
                        </div>
                      </div>



                        <!--<div v-if="family === 'PRODUCTS UPGRADE' && upgrades.cart.length > 1" class="col-md-12">
                          <button style="width: 100%; color: #c9302c; border-color: #c9302c; background-color: transparent;" @click="addToCartBundle(upgrades.cart)">
                            UPGRADE ALL FOR {{upgrades.total}} {{upgrades.cart[0].currency}}
                          </button>
                        </div>-->
<!--                      </div>-->
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="orders_loaded && !myorders" class="widget-content">
                <div class="row">
                  <div class="col-md-12" v-cloak>
                    <p>Ops, no orders.</p>
                    <button class="btn btn-primary" @click="addOrder()">Register now your first product</button>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import auth from '../auth'
  import client from '../auth/client.js'
  import {router} from '../main'
  //import {loading} from '../main'


  export default {
    data() {
      return {
        counter: [],
        line: false,
        modalProduct: null,
        modalCart: [],
        global_loader: true,
        welcomeMessage: true,
        getAll: true,
        activeAll: {},
        getBuy: false,
        getPurchases: false,
        loading: true,
        loadingCatalog: true,
        companies: null,
        mycompany: localStorage.getItem('reseller'),
        myorders:'',
        catalog: '',
        familyCatalog: [],
        familyPrice:["OWNED", "FREE", "TRIAL / EVALUATION"],
        //onlyForYou:["PRODUCTS UPGRADE", "BUNDLES COMPLETION", "PARTNERS PROMOS"],
        onlyForYou:["BUNDLES COMPLETION", "PRODUCTS UPGRADE"],
        myproducts:'',
        upgrades: null,
        orders_loaded: false,
        ready: false,
        err: null,
        email: null,
        checked: false,
        country: null,
        cart: [],
        totalProdOnlyForYou: null,
        get utente(){
          return JSON.parse(localStorage.getItem('userdata')) || 0;
        },
        get canBuy(){
          console.log(localStorage.getItem('canBuy'))
          return localStorage.getItem('canBuy') || false;
        },
        optionDate: {
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      }
    },
    watch: {
      ready: async function(val){
        this.loading = true
        if (val == true){
          var user_id = this.utente.id
          if (localStorage.getItem('reseller')==0 || localStorage.getItem('reseller')=='undefined'){
            var company = this.companies[0].id

          }else{
            var company = localStorage.getItem('reseller')
          }
          this.mycompany = company
          if (company){
            //auth.getFreeProducts(this, user_id, company)
            await auth.getCatalog(this, user_id, company)
            await auth.getOrders(this, user_id, company)
            auth.getCanbuy(this)
          }
        }
      },
      orders_loaded: function(val){
        this.takeFamily();
        if (this.myorders.length == 0){
          /* se non ho prodotti registrato redirect su ADD-ORDER */
            //router.push('/add-order');
        }
        if(val){
          this.familyPrice.forEach(family => {
            if(typeof this.counter[family] === 'undefined') this.counter[family] = 0
          })
          this.myproducts.forEach(product => {
              if ((typeof product.license_type === 'undefined' || product.license_type === null || product.license_type === 'REGULAR')) this.counter['OWNED']++            
              if ((product.license_type === 'NFR' || product.license_type === 'nfr')) this.counter['OWNED']++
              if ((product.license_type === 'FREE' || product.license_type === 'free')) this.counter['FREE']++
              if((product.license_type === 'TRIAL' || product.license_type === 'trial' || product.license_type === 'TEST' || product.license_type === 'test')) this.counter['TRIAL / EVALUATION']++
          })

            //console.log('counter',this.counter)
        }

        //})
      },
      catalog: function(val){
        this.takeFamily();
        this.setLine();
      }
    },
    methods: {
      setLine() {
        let bundle = false
        let upgrade = false
        for (let i= 0; i < this.catalog.length; i++){
          if(this.catalog[i].isBundle){
            if (this.catalog[i].from.length > 0 || (this.catalog[i].price !== this.catalog[i].special_price)){
              bundle = true
            }
          }
          if(this.catalog[i].isUpgrade){
            if (!this.purchased(this.catalog[i].id)){
              upgrade = true
            }
          }
        }
        if (bundle && upgrade) {
          this.line = true
        }
      },
      insertIdInModal(productId){
        this.modalProduct = null;
        this.modalCart = [];
        for (let i = 0; i<this.catalog.length; i++){
          if (this.catalog[i].id === productId){
            this.modalProduct = this.catalog[i]
            
            
            if(typeof this.modalProduct.addToCart === 'object' && this.modalProduct.addToCart !== null){
              this.modalProduct.addToCart = Object.values(this.modalProduct.addToCart);
            }
            console.log(this.modalProduct.addToCart)
            for (let j = 0; j < this.modalProduct.addToCart.length; j++){

              for(let k = 0; k < this.catalog.length; k++){

                if(this.catalog[k].code == this.modalProduct.addToCart[j].code){
                  if(!this.modalCart.includes(this.catalog[k].ProductName)){
                    this.modalCart.push(this.catalog[k].ProductName)
                  }
                }
              }
              /*let temp = this.modalProduct.addToCart[j].code.split('-')
              let tempItem = null
              if(temp[0] === 'swam') {
                tempItem = 'SWAM'
                for(let h = 1; h<temp.length; h++){
                  tempItem = tempItem + ' ' + temp[h]
                }
              } else {
                tempItem = ''
                for(let k = 0; k<temp.length; k++){
                  tempItem = tempItem + ' ' + temp[k]
                }
              }
              this.modalCart.push(tempItem)*/
            }
          }
        }
      },
      indexMyProd(id){
        for(let i = 0; i<this.myproducts.length; i++){
          if(this.myproducts[i].id === id){
            return i;
          }
        }
        return false;
      },
      getToken(id_file,file, product){
        window.fbq('trackCustom', 'Download', { platform: file.operating_system, version: file.version, architecture: file.architecture, product: product.ProductName, family: product.family })
        var token_min = process.env.TOKEN_DURATION
        auth.getToken(this, id_file, token_min, product.license_type)
      },
      imageUrlAlt(event) {
          event.target.src = "static/images/no_image.jpg"
      },
      /**
       * @param type
       *
       */
      selectTab(type){
        this.resetActiveAll();
        this.takeFamily();
        if(type === 'all'){
          this.getAll = true;
          this.getPurchases = false;
          this.getBuy = false;
          if(document.getElementById('all') !== null){
            document.getElementById('all').style.cssText = 'font-weight: bold; border-bottom: thin solid;';
            document.getElementById('your').style.cssText = 'font-weight: normal; border-bottom: none;';
            document.getElementById('only').style.cssText = 'font-weight: normal; border-bottom: none;';
          }
          this.$forceUpdate();
        } else if(type === 'your') {
          this.getAll = false;
          this.getPurchases = true;
          this.getBuy = false;
          if(document.getElementById('your') !== null){
            document.getElementById('all').style.cssText = 'font-weight: normal; border-bottom: none;';
            document.getElementById('your').style.cssText = 'font-weight: bold; border-bottom: thin solid;';
            document.getElementById('only').style.cssText = 'font-weight: normal; border-bottom: none;';

            $('a[href="#OWNED"]').trigger('click');
          }
          this.$forceUpdate();
        } else if(type === 'only'){
          this.getAll = false;
          this.getPurchases = false;
          this.getBuy = true;
          if(document.getElementById('only') !== null){
            document.getElementById('all').style.cssText = 'font-weight: normal; border-bottom: none;';
            document.getElementById('your').style.cssText = 'font-weight: normal; border-bottom: none;';
            document.getElementById('only').style.cssText = 'font-weight: bold; border-bottom: thin solid;';
          }
          this.$forceUpdate();
        } else {
          this.getAll = true;
          this.getPurchases = false;
          this.getBuy = false;
          if(document.getElementById('all') !== null){
            document.getElementById('all').style.cssText = 'font-weight: bold; border-bottom: thin solid;';
            document.getElementById('your').style.cssText = 'font-weight: normal; border-bottom: none;';
            document.getElementById('only').style.cssText = 'font-weight: normal; border-bottom: none;';
          }
          this.$forceUpdate();
        }
        this.$forceUpdate();
      },
      /**
       *
       *
       */
      getCookieMessage(){
        this.checked = true;
        this.welcomeMessage = false;
        /*let stringCookies = document.cookie;
        let listCookies = stringCookies.split(';');
        for(var i = 0; i <listCookies.length; i++) {
          let tempCoockie = listCookies[i];
          let keyValue = tempCoockie.split('=')
          keyValue[0] = keyValue[0].replace(/\s/g, '');
          if(keyValue[0] === 'checked'){
            if(keyValue[1] === 'true'){
              this.checked = true;
              this.welcomeMessage = false;
            } else {
              this.checked = false;
            }
          }

        }*/
      },
      /**
       *
       * @param checked
       */
      welcomeMessageExit(checked, type = null){
        if(checked){
          let d = new Date();
          d.setTime(d.getTime() + (12*30*24*60*60*1000));
          let expires = "expires="+ d.toUTCString();
          document.cookie = "checked=true;" + expires + ";path=/";
        }
        this.welcomeMessage = !this.welcomeMessage;
        if(type !== null && !this.welcomeMessage){
          this.selectTab(type)
        }
      },
      goAddOrder(){
        if(checked){
          let d = new Date();
          d.setTime(d.getTime() + (12*30*24*60*60*1000));
          let expires = "expires="+ d.toUTCString();
          document.cookie = "checked=true;" + expires + ";path=/";
          this.welcomeMessage = !this.welcomeMessage;
          router.push('/add-order');
        } else {
          this.welcomeMessage = !this.welcomeMessage;
          router.push('/add-order');
        }
      },
      getOrders(){
        this.loading = true
        var user_id = this.utente.id
        if (this.mycompany){
          auth.getOrders(this, user_id, this.mycompany)
        }


      },
      getCatalog(){
        this.loading = true
        var user_id = this.utente.id
        if (this.mycompany){
          auth.getCatalog(this, user_id, this.mycompany)
        }
      },
      getKeys(orderIndex, productIndex){
        var mykeys = this.myorders[orderIndex].products[productIndex].keys
        auth.getKeys(this, mykeys)
      },
      getProdKeys(productIndex, item){
        auth.getDownload(this, item.id)
        auth.getKeys(this, item.id)
      },
      getDownload(productIndex, item){
        /*console.log('item',item);
        console.log('productIndex',productIndex);
        console.log('this.myproducts',this.myproducts);
        for(let i = 0; i<this.myproducts.length; i++){
          if(this.myproducts[i].id === item.id){
            var product = this.myproducts[i].id
            var mykeys = this.myproducts[i].keys
          }
        }*/
        this.loading = true
        auth.getDownload(this, item.id, item)
        //auth.getKeys(this, item)
      },
      addOrder(){
        router.push('/add-order');
      },
      addProduct(url){
        /*fastspring.builder.reset();
        fastspring.builder.add(productId);
        var utente = JSON.parse(localStorage.getItem('userdata'))
        console.log(utente)
        var payload={"firstName":utente.first_name,"lastName":utente.last_name,"email":utente.email};
        fastspring.builder.recognize(payload);
        fastspring.builder.checkout();*/
        window.open(url, "_blank");
      },
      sendEmail(item){
        auth.sendEmail(this, item.token, item.company, item.user)
      },
      takeFamily(){
        //console.log(this.catalog)
        for(let i = 0; i<this.catalog.length; i++){
          if(!this.familyCatalog.includes(this.catalog[i].family)){
            this.familyCatalog.push(this.catalog[i].family)
          }
        }
        if(this.familyCatalog.length > 0) {
          this.global_loader = false;
          return true;
        } else {
          this.global_loader = false;
        }
      },
      purchased(id){
        for(let i = 0; i<this.myproducts.length; i++){
          if(this.myproducts[i].id === id && this.myproducts[i].license_type != 'FREE' && this.myproducts[i].license_type != 'TRIAL' && this.myproducts[i].license_type != 'TEST'){
            return true;
          }
        }
        return false;
      },
      showActiveAll(item){
        //this.counter = [];
        this.activeAll[item] = !this.activeAll[item];
        this.$forceUpdate();

      },
      familyPriceChoice(product, family){
        
        if((typeof product.license_type === 'undefined' || product.license_type === null || product.license_type === 'REGULAR') && family === 'OWNED') {
        
          return true
        }
        if((product.license_type === 'NFR' || product.license_type === 'nfr') && family === 'OWNED') {
         

          return true
        }
        if((product.license_type === 'FREE' || product.license_type === 'free') && family === 'FREE') {
        

          return true
        }
        if((product.license_type === 'TRIAL' || product.license_type === 'trial' || product.license_type === 'TEST' || product.license_type === 'test') && family === 'TRIAL / EVALUATION') {
         

          return true
        }
      },
      resetActiveAll(){
        for(let i in this.activeAll){
          this.activeAll[i] = false;
        }
      },
      async addToCart(product){
        window['TwoCoInlineCart'].cart.setSignature();
        window['TwoCoInlineCart'].products.removeAll();
        window['TwoCoInlineCart'].cart.setCurrency(product.currency);
        window['TwoCoInlineCart'].cart.setReturnMethod({
          type: 'redirect',
          url : process.env.REDIRECT_URL
        });
        if(process.env.NODE_ENV !== 'production'){
          window['TwoCoInlineCart'].cart.setTest(true);
        }

        window['TwoCoInlineCart'].products.add({
            code: product.code,
            quantity: 1,
            //price: product.price
        });


        console.log('cart',window['TwoCoInlineCart']);
        
        //console.log('products',window['TwoCoInlineCart'].products.list)
        //window['TwoCoInlineCart'].cart.setAutoAdvance(true);
       // let response  = await auth.signature(this,product);

        //console.log('signature',response)
        //window['TwoCoInlineCart'].cart.setAutoAdvance(true);
        //window['TwoCoInlineCart'].cart.setSignature(response.data.signature);
        window['TwoCoInlineCart'].cart.checkout();

        //this.$root.cart = window['TwoCoInlineCart'].products.list;
      },

     async addToCartBundle(products,special_price){
      console.log(special_price);
        window['TwoCoInlineCart'].products.removeAll();
        let items = [];
        if(!Array.isArray(products)){
         Object.keys(products).forEach(function (entry) {
          //if(special_price > products[entry].price) products[entry].price = special_price;
            items.push({
                code: products[entry].code,
                //quantity: 1,
                price: {'EUR' : parseInt(products[entry].price), 'USD' : parseInt(products[entry].price),}
            });
         });
        } else {
          products.forEach(function(entry) {
            //if(special_price < entry.price) entry.price = special_price;
            items.push({
                code: entry.code,
                //quantity: 1,
                price: {'EUR' : parseInt(entry.price), 'USD' : parseInt(entry.price),}
            });
          });
        }

        window['TwoCoInlineCart'].cart.setCurrency(products[0].currency);
        window['TwoCoInlineCart'].cart.setReturnMethod({
          type: 'redirect',
          url : process.env.REDIRECT_URL
        });
 
        if(process.env.NODE_ENV !== 'production'){
          window['TwoCoInlineCart'].cart.setTest(true);
        }


        window['TwoCoInlineCart'].products.addMany(items);

        console.log(window['TwoCoInlineCart'].cart);
        //window['TwoCoInlineCart'].cart.setCartLockedFlag(true);
        let response  = await auth.signature(this,products);

        //console.log('signature',response)
        //window['TwoCoInlineCart'].cart.setAutoAdvance(true);
        window['TwoCoInlineCart'].cart.setSignature(response.data.signature);
        window['TwoCoInlineCart'].cart.checkout();
      }
    },
    async created(){
      this.loading = true
      this.companies = auth.getCompany(this)
      var fbloaded = false
      if(fbloaded === false){
        if(this.utente.email){
          this.$analytics.fbq.init(process.env.FB_PIXEL, {uid: this.utente.uid, em: this.utente.email.toLowerCase(), fn: this.utente.first_name.toLowerCase(), ln: this.utente.last_name.toLowerCase() })
          this.$analytics.fbq.event('PageView')
        }
      }
    },
    mounted() {
      this.loading = true
      geoip2.country(
        success => {
          //const currencyType = success.country.iso_code === "US" ? "NorthAmerican" : "French";
          //AutoNumeric.multiple("[data-currency]", AutoNumeric.getPredefinedOptions()[currencyType]);
          //console.log('geoip',success.country);
          this.country = success.country.iso_code;
        },
        error => {
          console.warn("Error occured by getting geolocation.");
        }
      );
    },
    beforeMount() {
      this.loading = true
      let self = this
      this.getCookieMessage();
      if (localStorage.getItem('typetab')) {
        let type = localStorage.getItem('typetab')
        this.selectTab(type)
      } else {
        this.selectTab('your')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#only{
  /*background-color:#c9302c !important;
  border:0px !important;*/
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.check-am {
  width:30px;
  height:30px;
  background:white;
  border:2px solid #555;
  margin-top: -1px !important;
  margin-right: 2px !important;
}

.triangle{
  width: 0;
  height: 0;

  border-right: 10px solid transparent;
  border-bottom: 15px solid transparent;
  border-top: 15px solid transparent;
  position: absolute; top: 18px; left: 75px;
}

.triangle-trial{
  border-left: 10px solid #d67e27;
}

.rectangle-trial{
  background: #d67e27;
}
.rectangle-trial.expired{
  min-width:140px !important;
  background: #c9302c !important;
}
.triangle-trial.expired{
  left:135px !important;
  border-left: 10px solid #c9302c !important;
}

.triangle-nfr{
  border-left: 10px solid #1e88e5;
}

.rectangle-nfr{
  background: #1e88e5;
}

.triangle-free{
  border-left: 10px solid #2ca02c;
}

.rectangle-free{
  background: #2ca02c;
}

.rectangle {
  min-width: 80px;
  height: 30px;
  position: absolute; top: 18px; left: -5px;
  padding:10px;
}
.rectangle h4{
  position: absolute !important;
  top: 0 !important;
}

.rectangle-discontinue {
  min-width: 80px;
  height: 30px;
  position: absolute; top: 55px; left: -5px;
}

.triangle-discontinue{

  border-right: 10px solid transparent;
  border-bottom: 15px solid transparent;
  border-top: 15px solid transparent;
  position: absolute; top: 55px; left: 75px;
}

.triangle-discontinue-color{
  border-left: 10px solid #c9302c;
}

.rectangle-discontinue-color{
  background: #c9302c;
}
.rectangle-discontinue h4{
  padding: 10px !important;
  margin-top: -1px !important;
  font-weight:bold;
  text-transform:uppercase;
}

.rectangle h4{
  font-weight:bold !important;
  font-size:105%;
  margin-top: 8px !important;
  margin-left: 10px;
  position: absolute;
}
.nomeprodotto p{
  color:#9f9e9e;
}

.prodotto{
  height:540px;
}

.arrow-5 {

  position: relative;
  height: 0px; width: 0px;
  border: 26px solid;
  border-color:
      #c9302c
      #c9302c
      transparent
      transparent;
  transform: rotate(45deg);
}

.arrow-5:before {
  content: '';
  position: absolute;
  top: 0px; right: 0px;
  display: block;
  height: 26px; width: 40px;
  background-color: #c9302c;
  transform:
      rotate(-45deg)
      translate(3px, 5px);
}

.badge-notify{
  width:16px;
  height:16px;
  text-align: center;
  margin: auto;
  background:red;
  position:absolute;
  top: 10px;
  right: 0px;
  padding: 2px
}
.nav.nav-tabs a{
  display:block;
  height:100%;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue